export default {
  showFooter: true,
  isSidebarCompact: false,
  showBreadcrumb: true,
  menuAutoCollapsed: false,
  mode: 'light',
  layout: 'side',
  splitMenu: false,
  sideMode: 'light',
  isFooterAside: false,
  isSidebarFixed: true,
  isHeaderFixed: true,
  isUseTabsRouter: true,
  showHeader: true,
  brandTheme: '#0052D9',
};
